import React, { useEffect, useState } from "react";
import { useNoIndex } from "@/lib/usePageSeo";
import { useSearchParams, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";

/**
 * Mock Sentoo processing page. In live mode, this page is bypassed and the
 * customer is redirected straight to Sentoo. In mock/dev mode, we simulate a
 * payment success in ~2.5s, then redirect to /checkout/success.
 */
export default function CheckoutProcessingPage() {
  useNoIndex();
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const orderId = params.get("order_id");
  const [msg, setMsg] = useState("Connecting to Sentoo…");

  useEffect(() => {
    if (!orderId) {
      navigate("/");
      return;
    }
    const steps = [
      [600, "Verifying order details…"],
      [1200, "Authorizing payment…"],
      [2000, "Confirming with bank…"],
    ];
    const timers = steps.map(([t, m]) => setTimeout(() => setMsg(m), t));
    const finish = setTimeout(async () => {
      try {
        await api.post(`/orders/${orderId}/mock-complete`);
      } catch {}
      navigate(`/checkout/success?order_id=${orderId}`);
    }, 2600);
    return () => {
      timers.forEach(clearTimeout);
      clearTimeout(finish);
    };
  }, [orderId, navigate]);

  return (
    <div data-testid="checkout-processing" className="bg-[#0F0F0F] min-h-[70vh] grid place-items-center">
      <div className="text-center max-w-md px-4">
        <div className="w-20 h-20 rounded-full mx-auto border-4 border-[#FF6600] border-t-transparent animate-spin" />
        <div className="mt-8 font-display text-2xl font-bold">Processing Payment</div>
        <p className="mt-2 text-[#A3A3A3] text-sm">{msg}</p>
        <div
          data-testid="checkout-processing-test-banner"
          className="mt-6 rounded-md border border-amber-500/50 bg-amber-500/10 px-4 py-3 text-amber-200 text-xs font-semibold"
        >
          TEST MODE — Simulating payment. No real transaction is being processed.
        </div>
      </div>
    </div>
  );
}
